import React from 'react';
import FIScoreboard from './FIScoreboard';

export default function FIScoreboardPage({ user, managedOwner }) {
  return <FIScoreboard user={user} managedOwner={managedOwner} />;
}
